import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const DiscordIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.095 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.095 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
  </svg>
);

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
  </svg>
);

const YouTubeIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

const MediumIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M13.54 12a6.8 6.8 0 0 1-6.77 6.82A6.8 6.8 0 0 1 0 12a6.8 6.8 0 0 1 6.77-6.82A6.8 6.8 0 0 1 13.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z" />
  </svg>
);

const RedditIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
    <path d="M12 0C5.373 0 0 5.373 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12c0-6.627-5.373-12-12-12zm6.066 13.71c.147.307.216.637.191.972a2.31 2.31 0 0 1-.394 1.193c-.349.5-.873.862-1.467 1.089a7.59 7.59 0 0 1-1.98.478 14.08 14.08 0 0 1-2.416.131 14.08 14.08 0 0 1-2.416-.131 7.59 7.59 0 0 1-1.98-.478c-.594-.227-1.118-.59-1.467-1.089a2.31 2.31 0 0 1-.394-1.193 1.96 1.96 0 0 1 .191-.972c.148-.307.37-.573.644-.78a.924.924 0 0 1-.096-.415c0-.258.104-.506.29-.688a.97.97 0 0 1 .688-.285c.258 0 .506.104.688.285.547-.384 1.196-.645 1.882-.77l.354-1.677a.238.238 0 0 1 .286-.19l1.872.396a.68.68 0 0 1 .63-.424.694.694 0 0 1 .694.694.694.694 0 0 1-.694.694.68.68 0 0 1-.63-.424l-1.66-.35-.314 1.49c.67.13 1.303.387 1.838.762a.97.97 0 0 1 .688-.285.97.97 0 0 1 .688.285c.186.182.29.43.29.688a.924.924 0 0 1-.096.415c.274.207.496.473.644.78zm-8.17.513a.87.87 0 1 0 0-1.74.87.87 0 0 0 0 1.74zm4.99-.87a.87.87 0 1 0-1.74 0 .87.87 0 0 0 1.74 0zm-1.034 2.525c-.547.365-1.276.547-2.052.547-.776 0-1.505-.182-2.052-.547a.29.29 0 0 1 .324-.482c.44.295 1.058.45 1.728.45.67 0 1.288-.155 1.728-.45a.29.29 0 0 1 .324.482z" />
  </svg>
);

const socialLinks = [
  { href: 'https://twitter.com/COTInetwork', icon: XIcon, label: 'X' },
  { href: 'https://discord.gg/coti-foundation', icon: DiscordIcon, label: 'Discord' },
  { href: 'https://t.me/COTInetwork', icon: TelegramIcon, label: 'Telegram' },
  { href: 'https://www.youtube.com/@COTIGroup', icon: YouTubeIcon, label: 'YouTube' },
  { href: 'https://medium.com/cotinetwork', icon: MediumIcon, label: 'Medium' },
  { href: 'https://www.reddit.com/r/cotinetwork/', icon: RedditIcon, label: 'Reddit' },
];

const Footer = () => {
  return (
    <footer className="w-full py-6 flex flex-col items-center gap-4 relative z-10 text-[11px] font-medium tracking-wide text-muted-foreground">
      <div className="flex flex-row flex-wrap items-center justify-center gap-4 sm:gap-6">
        <a
          href="https://coti.io"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground transition-colors whitespace-nowrap"
        >
          &copy; 2026 COTI
        </a>
        <div className="flex gap-4 sm:gap-6">
          <a
            href="https://docs.coti.io/coti-documentation/coti-privacy-portal"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors whitespace-nowrap"
          >
            Docs
          </a>
          <Link
            to="/terms"
            className="hover:text-foreground transition-colors whitespace-nowrap"
          >
            Terms of Use
          </Link>
        </div>
      </div>
      <div className="flex gap-4 items-center">
        <a
          href="https://coti.io"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-foreground transition-colors"
          aria-label="Home"
        >
          <Home className="w-4 h-4" />
        </a>
        {socialLinks.map(({ href, icon: Icon, label }) => (
          <a
            key={label}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
            aria-label={label}
          >
            <Icon />
          </a>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
